import { useDispatch, useSelector } from 'react-redux';
import { getQueryParams } from '../routing/getQueryParams';
import { getHublet, getIsNewPortalCreated } from '../store/app/selectors';
import { getPortalId } from '../store/auth/selectors';
import { checkIfLoggedInIfNotExistingAccount } from '../http/endpointStateChecks';
import { isntExistingUserExistingAccount } from '../app/verificationTypeSelectors';
import { getSignupBody } from '../http-signup/getSignupBody';
import { getLoginBody } from '../http-login/getLoginBody';
import { integratedAppRedirect } from '../store/integrations/action-creators';
export const getIntegratedAppRedirectParams = state => {
  const queryParams = getQueryParams();
  const isNewPortal = getIsNewPortalCreated(state);
  const isLoggedInIfNotExistingAccount = checkIfLoggedInIfNotExistingAccount(state);
  const isntExistingAccount = isntExistingUserExistingAccount(state);
  const hubId = getPortalId(state);
  const hublet = getHublet(state);
  const signupBody = getSignupBody(state);
  const loginBody = getLoginBody(state);
  return {
    queryParams,
    isNewPortal,
    isLoggedInIfNotExistingAccount,
    isntExistingAccount,
    hubId,
    hublet,
    signupBody,
    loginBody
  };
};
export const useIntegratedAppRedirect = () => {
  const dispatch = useDispatch();
  const redirectParams = useSelector(getIntegratedAppRedirectParams);
  const redirectToConnect = () => {
    dispatch(integratedAppRedirect(redirectParams));
  };
  return {
    redirectToConnect
  };
};